import { Component, OnInit } from '@angular/core';
import {EcastudentsService  } from './ecastudents.services';

@Component({
  selector: 'app-ecastudents',
  templateUrl: './ecastudents.component.html',
  styleUrls: ['./ecastudents.component.css']
})
export class EcastudentsComponent implements OnInit {
  studentList: any[];
  selectedStudent;

  constructor(
    private  studentService:  EcastudentsService
  ) { }

  ngOnInit(): void {
    this.getStudentList();
  }


  getStudentList(){
    this.studentService.userList({userType:'STUDENT'}).subscribe((dataResult: any)=>{
      // console.log("student list",dataResult.list);
      this.studentList = dataResult.list;
      console.log(this.studentList);
      this.selectedStudent = this.studentList[0];
    })
  }

  onDetails(studentCode: string) {
    console.log(studentCode);
    for (let student of this.studentList) {
      if (student.code == studentCode) {
        this.selectedStudent = student;
      }
    }
    console.log(this.selectedStudent);
  }

  onDeleteStudent(userId:string){
    this.studentService.deleteUser({userId:userId}).subscribe((dataResult:any)=>{
      this.getStudentList();
    })

  }

}
